// extracted by mini-css-extract-plugin
export var icon = "IconList-module--icon--6ee22";
export var item = "IconList-module--item--d5fb7";
export var list = "IconList-module--list--002a3";